export const USZipCodeRegexMask = [/\d/, /\d/, /\d/, /\d/, /\d/];

export const CAPostalCodeRegexMask = [/[a-zA-Z]/, /\d/, /[a-zA-Z]/, /\s/, /\d/, /[a-zA-Z]/, /\d/];
export const CAPostalCodeRegexMaskWithoutSpace = [/[a-zA-Z]/, /\d/, /[a-zA-Z]/, /\d/, /[a-zA-Z]/, /\d/];
